import { Box, Typography } from "@mui/material";

const DashboardForecastingColumns = ({ isMobile }) => [
    {
        field: "name",
        headerName: "Name",
        flex: 1,
        renderCell: ({ row: { _id, name } }) => (
            <a className="hive-dashboard-opps-link" href={`/opportunities/${_id}`}>{name}</a>
        ),
    },
    ...(isMobile ? [] : [
        {
            field: "quoteNumber",
            headerName: "Quote #",
            flex: 1,
            renderCell: ({ row: { quoteNumber, quoteId } }) =>
                quoteId ? (
                    <a className="hive-grid-link-cell" href={`/base-unique-quote/${quoteId}`}>
                        {quoteNumber}
                    </a>
                ) : (
                    quoteNumber || ""
                ),
        },
        {
            field: "customer",
            headerName: "Customer",
            flex: 1,
            renderCell: ({ row: { customer } }) => customer?.organizationName || "",
            valueGetter: (params) => params?.organizationName || "",
        },
        {
            field: "owner",
            headerName: "Owner",
            flex: 1,
            renderCell: ({ row: { owner } }) => owner ? `${owner.firstName} ${owner.lastName}` : "Unassigned",
            valueGetter: (params) => params ? `${params.firstName || ""} ${params.lastName || ""}`.trim() : "Unassigned",
        },
        {
            field: "total",
            headerName: "Total",
            flex: 1,
            renderCell: ({ row: { total } }) => (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    <Typography sx={{ color: "#2e7d32", fontWeight: 500, fontSize: "0.875rem" }}>
                        {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                        }).format(total || 0)}
                    </Typography>
                </Box>
            ),
        },
        {
            field: "winProbability",
            headerName: "Win %",
            flex: 1,
            renderCell: ({ row: { winProbability } }) => `${Number(winProbability) || 0}%`,
        },
        {
            field: "earliestShipDate",
            headerName: "Earliest Ship Date",
            flex: 1,
            renderCell: ({ row: { earliestShipDate } }) => earliestShipDate ? earliestShipDate.split("T")[0] : "",
        },
        {
            field: "closeDate",
            headerName: "Close Date",
            renderCell: ({ row: { closeDate } }) => closeDate ? closeDate.split("T")[0] : "",
            flex: 1,
        },
    ]),
    {
        field: "salesStage",
        headerName: "Stage",
        flex: 1,
        renderCell: ({ row: { salesStage } }) => (
            <label className={`badge  ${salesStage === '01 - Lead' ? 'bg-light-primary' : salesStage === '08 - Won' ? 'bg-light-success' : salesStage === '05 - Committee Approval' ? 'bg-light-warning' : salesStage === '04 - Internal Revision' ? 'bg-light-danger' : salesStage === '06 - Quote Sent' ? 'bg-light-primary' : salesStage === '02 - Identified' ? 'bg-light-dark' : salesStage === '03 - Committee' ? 'bg-light-secondary' : salesStage === "07 - External Revision" ? 'bg-light-danger' : 'bg-light-info'}`} style={{ minHeight: '75%', minWidth: '75%', padding: "0", lineHeight: '3', fontSize: '14px' }}>{salesStage}</label>
        ),
    },
];

export default DashboardForecastingColumns;
